<template>
  <div class="app">
    <template v-if="landlordChatBotEnabled">
      <a
        v-if="showFia"
        href="//telia-anslutning.humany.net/fia"
        style="display: none;">
        Customer service
      </a>
      <a
        v-if="!showFia"
        href="//telia-anslutning.humany.net/adam-telia-test"
        style="display: none;">
        Customer service
      </a>
    </template>
    <router-view />
  </div>
</template>
<script>
import { computed, defineComponent, ref, watch } from '@vue/composition-api'
import { RoutePath } from '@/router/enum'
import Features from '@telia/infra-feature-manager'

export default defineComponent({

  setup (_, context) {
    const landlordChatBotEnabled = computed(() => Features.LANDLORD_CHAT_BOT)
    const proxyChatBot = computed(() => Features.PROXY_CHAT_BOT)
    const alternativeChatBot = computed(() => Features.ALTERNATIVE_CHAT_BOT)

    const showFia = ref(false)

    watch(() => context.root.$route, (route) => {
      if (landlordChatBotEnabled.value) {
        showFia.value = !route.path.includes(RoutePath.LandlordPage)
      } else {
        const BLOCK = 'block'
        const NONE = 'none'
        const CHAT_BOT_ID = 'chatbot'
        const chatBotScript = document.createElement('script')
        chatBotScript.id = CHAT_BOT_ID
        if (!proxyChatBot.value && !alternativeChatBot.value || proxyChatBot.value && alternativeChatBot.value) {
          chatBotScript.src = 'https://wds.ace.teliacompany.com/wds/instances/Teliase/ACEWebSDK.min.js'
        }
        if (proxyChatBot.value && !alternativeChatBot.value) {
          chatBotScript.src = 'https://proxy11.ace.teliacompany.net/wds/15.3.1/visitor/js/modules/ACEWebSDK.min.js'
        }
        if (!proxyChatBot.value && alternativeChatBot.value) {
          chatBotScript.src = 'https://wds.ace.teliacompany.com/wds/15.3.1/visitor/js/modules/ACEWebSDK.min.js'
        }
        const chatBotScriptElement = document.getElementById(CHAT_BOT_ID)
        const renderedChatBotTrigger = document.getElementsByClassName('humany-trigger')[0]
        const renderedChatBotWidget = document.getElementsByClassName('humany-widget')[0]

        if (!route.path.includes(RoutePath.LandlordPage)) {
          if (!chatBotScriptElement) {
            document.getElementsByTagName('head')[0].appendChild(chatBotScript)
          } else if (renderedChatBotTrigger && renderedChatBotTrigger.style.display === NONE) {
            renderedChatBotTrigger.style.display = BLOCK
            if (renderedChatBotWidget && renderedChatBotWidget.style.display === NONE) {
              renderedChatBotWidget.style.display = BLOCK
            }
          }
        } else {
          if (renderedChatBotTrigger) {
            renderedChatBotTrigger.style.display = NONE
          }
          if (renderedChatBotWidget) {
            renderedChatBotWidget.style.display = NONE
          }
        }
      }
    })

    return {
      landlordChatBotEnabled,
      showFia
    }
  }
})
</script>
<style lang="scss">
.app {
  height: 100%;
}

</style>
